// components/Pricing.js
import React from 'react';
import './Pricing.css';

const Pricing = () => {
  const plans = [
    {
      id: 1,
      name: 'WhatsApp Verified',
      price: '20,000',
      period: '/100 leads',
      features: [
        'WhatsApp verification',
        'Multi-step forms',
        'AI filtering',
        'Real-time delivery',
        'Google Sheets integration'
      ],
      recommended: false
    },
    {
      id: 2,
      name: 'OTP Verified',
      price: '25,000',
      period: '/100 leads',
      features: [
        'Everything in WhatsApp',
        'OTP verification',
        'Advanced AI filtering',
        'Detailed form data',
        'Priority support'
      ],
      recommended: true
    },
    {
      id: 3,
      name: 'Call + WB Verified',
      price: '35,000',
      period: '/100 leads',
      features: [
        'Everything in OTP',
        'Manual call verification',
        'Audio recordings',
        'Highest intent leads',
        'Dedicated account manager'
      ],
      recommended: false
    }
  ];

  return (
    <section id="pricing" className="pricing-section fade-in-section">
      <div className="container">
        <h2 className="section-title">Simple, Transparent Pricing</h2>
        <p className="section-subtitle">
          Choose the plan that fits your business needs. No hidden fees, cancel anytime.
        </p>
        
        <div className="pricing-table">
          {plans.map((plan) => (
            <div key={plan.id} className={`pricing-card ${plan.recommended ? 'recommended' : ''}`}>
              {plan.recommended && <div className="recommended-badge">Recommended</div>}
              
              <h3 className="pricing-title">{plan.name}</h3>
              
              <div className="pricing-amount">
                <span className="currency">₹</span>
                <span className="price">{plan.price}</span>
                <span className="period">{plan.period}</span>
              </div>
              
              <ul className="pricing-features">
                {plan.features.map((feature, index) => (
                  <li key={index}>
                    <span className="check">✓</span> {feature}
                  </li>
                ))}
              </ul>
              
              <button className={`pricing-button ${plan.recommended ? 'recommended-button' : ''}`}>
                Get Started
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;